/* Rectangle « Mon compte » (sections/elite-compte.liquid).
   - Un clic simple sur l'icône compte de l'en-tête ou sur le lien compte du menu mobile ouvre le panneau.
     Ctrl/Cmd/Maj + clic et clic molette ne sont pas interceptés : le lien s'ouvre comme avant (nouvel onglet).
   - Ordinateur : rectangle accroché sous l'icône, un clic ailleurs le referme sans bloquer ce clic.
     Mobile (< 750 px) : panneau qui monte du bas avec un voile ; toucher le voile referme.
   - Déconnecté : le formulaire part vers la connexion Shopify avec l'e-mail (login_hint) et revient sur la
     page en cours (return_to). Le bouton Shop est inséré à la première ouverture seulement.
   - Retour de connexion (e-mail, Shop ou nouvel onglet) : le panneau se rouvre une fois, « Connexion réussie ». */
(() => {
  const racine = document.getElementById('ec-compte');
  if (!racine || racine.dataset.pret) return;
  racine.dataset.pret = '1';

  const panneau = racine.querySelector('.ec__panneau');
  const mobile = window.matchMedia('(max-width: 749px)');
  const connecte = racine.dataset.connecte === 'true';
  const DECLENCHEURS = '.header__icon--account, .menu-drawer__account, [data-ec-ouvrir]';
  const CLE_RETOUR = 'elite-compte-retour';
  let declencheur = null;
  let attenteOnglet = false;

  const memo = {
    lire: () => { try { return sessionStorage.getItem(CLE_RETOUR); } catch (e) { return null; } },
    poser: () => { try { sessionStorage.setItem(CLE_RETOUR, '1'); } catch (e) { /* navigation privée */ } },
    oublier: () => { try { sessionStorage.removeItem(CLE_RETOUR); } catch (e) { /* idem */ } }
  };

  /* Icône de l'en-tête : initiale du client une fois connecté */
  if (connecte && racine.dataset.initiale) {
    document.querySelectorAll('.header__icon--account').forEach(lien => {
      if (lien.querySelector('.ec-initiale')) return;
      const initiale = document.createElement('span');
      initiale.className = 'ec-initiale';
      initiale.setAttribute('aria-hidden', 'true');
      initiale.textContent = racine.dataset.initiale;
      lien.classList.add('ec-connecte');
      lien.prepend(initiale);
    });
  }
  if (racine.hasAttribute('data-actif')) {
    document.querySelectorAll(DECLENCHEURS).forEach(lien => {
      lien.setAttribute('aria-haspopup', 'dialog');
      lien.setAttribute('aria-controls', 'ec-panneau');
      lien.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------- Position sous l'icône (ordinateur) ---------- */
  function placer() {
    if (mobile.matches) return;
    const largeurVue = document.documentElement.clientWidth;
    const cible = declencheur && declencheur.getClientRects().length ? declencheur : null;
    const r = cible ? cible.getBoundingClientRect() : null;
    if (!r || !r.width) {
      racine.classList.add('ec--sans-pointe');
      racine.style.setProperty('--ec-top', '72px');
      racine.style.setProperty('--ec-right', '16px');
      return;
    }
    racine.classList.remove('ec--sans-pointe');
    const largeur = panneau.offsetWidth || 360;
    let droite = Math.max(12, largeurVue - r.right - 6);
    if (largeurVue - droite - largeur < 12) droite = Math.max(12, largeurVue - largeur - 12);
    const gauche = largeurVue - droite - largeur;
    const pointe = Math.min(largeur - 16, Math.max(16, r.left + r.width / 2 - gauche));
    racine.style.setProperty('--ec-top', `${Math.round(r.bottom + 10)}px`);
    racine.style.setProperty('--ec-right', `${Math.round(droite)}px`);
    racine.style.setProperty('--ec-pointe', `${Math.round(pointe)}px`);
  }

  /* ---------- Bouton Shop (inséré à la première ouverture) ---------- */
  function monterShop() {
    const zone = racine.querySelector('[data-ec-shop]');
    const modele = racine.querySelector('template[data-ec-shop-modele]');
    if (!zone || !modele || zone.dataset.monte) return;
    zone.dataset.monte = '1';
    const contenu = document.importNode(modele.content, true);
    const bouton = contenu.querySelector('shop-login-button');
    if (!bouton) {
      racine.classList.add('ec--sans-shop');
      return;
    }
    // mêmes réglages que le thème Horizon de Shopify (account-login-actions.js)
    bouton.setAttribute('full-width', 'true');
    bouton.setAttribute('persist-after-sign-in', 'true');
    bouton.setAttribute('analytics-context', 'loginWithShopSelfServe');
    bouton.setAttribute('flow-version', 'account-actions-popover');
    bouton.setAttribute('return-uri', window.location.href);
    bouton.addEventListener('completed', () => {
      memo.poser();
      window.location.reload();
    });
    zone.append(contenu);
  }

  /* ---------- Ouvrir / fermer ---------- */
  function marquer(ouvert) {
    document.querySelectorAll(DECLENCHEURS).forEach(lien => {
      if (lien.hasAttribute('aria-expanded')) lien.setAttribute('aria-expanded', String(ouvert));
    });
  }

  function ouvrir(depuis) {
    if (depuis) declencheur = depuis;
    monterShop();
    racine.hidden = false;
    placer();
    document.documentElement.classList.toggle('ec-verrou', mobile.matches);
    marquer(true);
    const champ = racine.querySelector('.ec__champ');
    const focus = champ && !mobile.matches ? champ : panneau;
    focus.focus({ preventScroll: true });
  }

  function fermer(rendreFocus) {
    if (racine.hidden) return;
    racine.hidden = true;
    document.documentElement.classList.remove('ec-verrou');
    marquer(false);
    if (rendreFocus && declencheur && declencheur.getClientRects().length) declencheur.focus({ preventScroll: true });
  }

  document.addEventListener('click', e => {
    if (!racine.hasAttribute('data-actif')) return;
    const lien = e.target.closest && e.target.closest(DECLENCHEURS);
    if (!lien || racine.contains(lien)) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (!racine.hidden && declencheur === lien) fermer(false);
    else ouvrir(lien);
  });

  racine.addEventListener('click', e => {
    if (e.target.closest('[data-ec-fermer], [data-ec-fond]')) fermer(true);
  });

  // Ordinateur : un clic ailleurs referme, et ce clic continue vers sa cible.
  // (Sur mobile c'est le voile qui ferme, au « click », pour ne pas déclencher ce qui est dessous.)
  document.addEventListener('pointerdown', e => {
    if (racine.hidden || mobile.matches) return;
    const chemin = e.composedPath();
    if (chemin.includes(panneau)) return;
    if (chemin.some(n => n instanceof Element && n.matches(DECLENCHEURS))) return;
    fermer(false);
  }, true);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !racine.hidden) fermer(true);
  });

  let image = 0;
  const suivre = () => {
    if (racine.hidden || image) return;
    image = requestAnimationFrame(() => {
      image = 0;
      if (mobile.matches) return;
      if (declencheur && declencheur.getBoundingClientRect().bottom < 0) fermer(false);
      else placer();
    });
  };
  window.addEventListener('scroll', suivre, { passive: true });
  window.addEventListener('resize', suivre);
  mobile.addEventListener('change', () => {
    if (racine.hidden) return;
    document.documentElement.classList.toggle('ec-verrou', mobile.matches);
    placer();
  });

  /* ---------- Déconnecté : formulaire e-mail et lien « nouvel onglet » ---------- */
  const form = racine.querySelector('[data-ec-form]');
  const onglet = racine.querySelector('[data-ec-onglet]');
  const retour = () => window.location.pathname + window.location.search;

  const ongletBase = onglet ? onglet.getAttribute('href') : '';
  function majOnglet() {
    if (!onglet) return;
    const url = new URL(ongletBase, window.location.origin);
    url.searchParams.set('return_to', retour());
    const champ = form && form.querySelector('.ec__champ');
    const email = champ ? champ.value.trim() : '';
    if (email && champ.checkValidity()) url.searchParams.set('login_hint', email);
    else url.searchParams.delete('login_hint');
    onglet.href = url.pathname + url.search;
  }

  if (form) {
    form.querySelector('[data-ec-retour]').value = retour();
    form.querySelector('.ec__champ').addEventListener('input', majOnglet);
    form.addEventListener('submit', () => {
      form.querySelector('[data-ec-retour]').value = retour();
      form.querySelector('.ec__champ').value = form.querySelector('.ec__champ').value.trim();
      memo.poser();
      form.querySelector('.ec__btn').disabled = true;
    });
    // retour arrière depuis la page Shopify (page restaurée du cache) : réactiver le bouton
    window.addEventListener('pageshow', () => { form.querySelector('.ec__btn').disabled = false; });
    majOnglet();
  }

  if (onglet) {
    onglet.addEventListener('click', () => {
      majOnglet();
      attenteOnglet = true;
    });
    // Connexion faite dans l'autre onglet : au retour sur celui-ci, on vérifie et on recharge si besoin.
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState !== 'visible' || !attenteOnglet) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', 'elite-compte');
        const html = await (await fetch(url, { credentials: 'same-origin' })).text();
        if (html.includes('data-connecte="true"')) {
          attenteOnglet = false;
          memo.poser();
          window.location.reload();
        }
      } catch (e) { /* réseau : on laisse le client recharger lui-même */ }
    });
  }

  /* ---------- Retour de connexion : on rouvre une fois, avec « Connexion réussie » ---------- */
  if (memo.lire()) {
    memo.oublier();
    if (connecte) {
      const ok = racine.querySelector('[data-ec-ok]');
      if (ok) ok.hidden = false;
      const icone = [...document.querySelectorAll('.header__icon--account')].find(l => l.getClientRects().length);
      ouvrir(icone || null);
    }
  }

  /* ---------- Éditeur de thème : sélectionner la section ouvre le panneau ---------- */
  document.addEventListener('shopify:section:select', e => {
    if (e.detail && e.detail.sectionId === 'elite-compte') ouvrir(declencheur || document.querySelector('.header__icon--account'));
  });
  document.addEventListener('shopify:section:deselect', e => {
    if (e.detail && e.detail.sectionId === 'elite-compte') fermer(false);
  });
})();
